<script setup lang="ts">
import type { CyclabilityCitiesData } from '@/composables/cyclability/cities/cyclabilityCitiesData'

defineOptions({
  name: 'CityCyclabilityPassagesHistoryMetric',
})

const props = defineProps<{
  showAllData?: boolean
  subtitle?: string
}>()

const { t } = useI18n()
const { writeCache } = useWriteCacheForMetric('cityCyclabilityPassagesHistory')

const cityDataCounter = inject('cityDataCounter') as ReturnType<typeof useCyclabilityCitiesData>
const { cityDateRange, cityDateRangeLimit, dataInRange, data: allData, city } = cityDataCounter

const { translateRange } = useDateTranslation()
const usedDateRange = computed(() => props.showAllData ? cityDateRange.value : cityDateRangeLimit.value)

function updateCachedData(data: CyclabilityCitiesData[]) {
  if (!city.value) {
    return
  }

  writeCache({
    city: city.value,
    dateRange: usedDateRange.value,
  }, {
    series: [
      {
        name: 'all',
        label: 'All',
        color: '#33488a',
        data: data.map(item => [formatDate(item.date), item.counter]) || [],
      },
    ],
  })
}

watch([dataInRange, allData], ([dataInRange, allData]) => {
  if (!allData) {
    return
  }

  if (props.showAllData) {
    updateCachedData(allData)
  } else {
    updateCachedData(dataInRange)
  }
}, { immediate: true })
</script>

<template>
  <MetricCard
    kpi="cityCyclabilityPassagesHistory"
    :used-filters="['dateRange']"
    :variables="{
      dateRange: usedDateRange,
    }"
  >
    <template #title>
      {{ t('cyclability.cycling_passages_history.title') }}
    </template>

    <template #range-subtitle>
      {{ t('dates.daterange_formated_human', translateRange(cityDateRange)) }}{{ subtitle ? ` - ${subtitle}` : '' }}
    </template>

    <template #default="{ data }">
      <BarMetric :data="data" />
    </template>
  </MetricCard>
</template>
